import React, {useState} from 'react';
import {useNavigation} from 'react-router-dom';
import {ContentLayout} from '../ContentLayout';
import {Layout} from 'antd';
import {HeaderLayout} from '../HeaderLayout';
import {SideMenu} from '../SideMenu';

const MainLayout = () => {
  const navigation = useNavigation();

  const [menuClicked, setMenuClicked] = useState(false);

  return (
    <Layout className={'main-layout-container'}>

      <SideMenu menuClicked={menuClicked} setMenuClicked={setMenuClicked} />
      <Layout className={'main-header-and-content-container'}>
        <HeaderLayout menuClicked={setMenuClicked} />
        <ContentLayout navigation={navigation} />
      </Layout>
    </Layout>
  );
};

export default MainLayout;
